import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/app/src/components/header/Header.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/navigation/NavigationArticlePage.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/ScrollUpPage.tsx")